import { Component } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { NacoService } from '../../domains/services/naco.service';
import { Signature } from '../../domains/values/signature';
import { User } from '../../domains/models/user';
import { Storage } from '@ubud/storage';

@Component({
    selector: 'naker-auth-page',
    template: '{{ message }}',
})
export class AuthPage {
    public message: string = 'Authenticating...';

    public constructor(private route: ActivatedRoute, private naco: NacoService, private storage: Storage) {
        this.route.queryParams.subscribe((params: Params) => this.handle(params));
    }

    public handle(params: Params): void {
        if (params.state) {
            this.naco.getState().then((state: string | null) => {
                if (state !== params.state) {
                    this.message = 'Invalid CSRF';

                    return;
                }

                this.authenticate(params);
            });
        } else {
            this.authenticate(params);
        }
    }

    private authenticate(params: Params): void {
        const signature: Signature = {
            expiresIn: params.expires_in,
            type: params.token_type,
            token: params.access_token,
        };

        this.naco.setUser(null);
        this.naco.setSignature(signature);

        this.naco.getUser().subscribe((user: User | null) => {
            if (null !== user) {
                this.storage.get('naco_intended_url').then((url: any) => {
                    this.storage.remove('naco_intended_url').then(() => {
                        window.location.href = url ? url : '/';
                    });
                });

                return;
            }

            this.message = 'Unauthenticated!';
        });
    }
}

